import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { TaskList, TaskListConfiguration, TaskListReorder } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class TaskListService {
  reorderTasksBS: EventEmitter<any> = new EventEmitter();
  tasksBaseUrl = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/tasks`;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  getTasks(taskListConfiguration: TaskListConfiguration): Observable<TaskList> {
    return this.asyncRequestService
      .post<TaskList>(`${this.tasksBaseUrl}`, taskListConfiguration)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  lazyLoadTasks(taskListConfiguration: TaskListConfiguration): Observable<TaskList> {
    return this.http
      .post<TaskList>(`${this.tasksBaseUrl}/lazyload`, taskListConfiguration)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  reorderTasks(taskList: TaskListReorder): Observable<TaskList> {
    return this.http
      .post<TaskList>(`${this.tasksBaseUrl}/reorder`, taskList)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
